import { c as _c } from "react/compiler-runtime";
import { Stack } from "@mui-wrapper";
import { Dialog, LinearProgress, Text } from "@flat-ui";
/**
 * Dialog to show export progress with cancellation support
 */
export function ExportAllDataDialog(t0) {
  const $ = _c(11);
  const {
    isOpen,
    currentPageNumber,
    onCancel
  } = t0;
  const progressMessage = currentPageNumber > 0 ? `Loading page ${currentPageNumber}...` : "Starting export...";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mb: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <br />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== progressMessage) {
    t3 = <Text variant="bodyM" sx={t1}>Your file will download automatically once all data is loaded.{t2}{progressMessage}</Text>;
    $[2] = progressMessage;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <LinearProgress sx={{
      mt: 1
    }} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <Stack spacing={3}>{t3}{t4}</Stack>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isOpen || $[8] !== onCancel || $[9] !== t5) {
    t6 = <Dialog title="Exporting all data" open={isOpen} showXButton={false} cancelText="Cancel" onCancel={onCancel}>{t5}</Dialog>;
    $[7] = isOpen;
    $[8] = onCancel;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}